// 拜访记录
import {dynamicPropsFn} from './util.js'
const YyVisitRecordList = resolve => require(['@/views/YyVisitRecord/List'], resolve)
const YyVisitRecordDetail = resolve => require(['@/views/YyVisitRecord/Detail'], resolve)
const YyVisitRecordNew = resolve => require(['@/views/YyVisitRecord/New'], resolve)
const YyVisitRecordEdit = resolve => require(['@/views/YyVisitRecord/Edit'], resolve)

export default [
  {
    name: 'YyVisitRecord_List',
    path: '/YyVisitRecord/list',
    component: YyVisitRecordList,
    meta: {
      keepAlive: false,
      title: '拜访记录列表',
    },
  },
  {
    name: 'YyVisitRecord_detail',
    path: '/YyVisitRecord/detail',
    component: YyVisitRecordDetail,
    meta: {
      keepAlive: false,
      title: '拜访记录详情',
    },
  },
  {
    name: 'YyVisitRecord_new',
    path: '/YyVisitRecord/new',
    component: YyVisitRecordNew,
    meta: {
      keepAlive: false,
      title: '新建拜访记录',
    },
  },
  {
    name: 'YyVisitRecord_edit',
    path: '/YyVisitRecord/edit',
    component: YyVisitRecordEdit,
    props: dynamicPropsFn,
    meta: {
      keepAlive: false,
      title: '编辑拜访记录',
    },
  },

]



// WEBPACK FOOTER //
// ./src/router/yyVisitRecord.js